export const PACE = {
  STATUS: {
    BELOW_PACE: 'Below Pace',
    ON_PACE: 'On Pace',
    ABOVE_PACE: 'Above Pace',
  },
};
